const projectBillingTypes = {
  tm: { id: 'tm', name: 'Time & Materials' },
  fixed: { id: 'fixed', name: 'Fixed Fee' },
  fixed_recurring: { id: 'fixed_recurring', name: 'Fixed Monthly' },
  non_billable: { id: 'non_billable', name: 'Non-Billable' },
};

export default projectBillingTypes;
